import { render, staticRenderFns } from "./WorkingFile.vue?vue&type=template&id=08ba87c9&"
import script from "./WorkingFile.vue?vue&type=script&lang=js&"
export * from "./WorkingFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports